import loadScript from '../util/loader';

const sections = {};

const selectors = {
  dataVideoId: 'data-video-id',
  dataVideoType: 'data-video-type',
  videoIframe: '[data-video-id]',
};

const classes = {
  loaded: 'loaded',
};

class LoadVideoNative {
  constructor(container) {
    this.container = container;
    this.player = this.container.querySelector(selectors.videoIframe);

    if (this.player) {
      this.videoID = this.player.getAttribute(selectors.dataVideoId);
      this.videoType = this.player.getAttribute(selectors.dataVideoType);

      if (this.videoType == 'native') {
        this.init();
      }
    }
  }

  init() {
    if (window.isPlyrLoaded) {
      this.loadNativePlayer();
    } else {
      // Load Plyr
      const videoLoad = {
        name: 'video-ui',
        version: '1.0',
      };
      loadScript(videoLoad).then(() => this.loadNativePlayer());
    }
  }

  loadNativePlayer() {
    const plyrOptions = {
      focusOnPlay: true,
    };

    const player = new Shopify.Plyr(this.player, plyrOptions);

    player.on('ready', (event) => {
      event.target.classList.add(classes.loaded);
    });

    window.isPlyrLoaded = true;
  }
}

const loadVideoNative = {
  onLoad() {
    sections[this.id] = new LoadVideoNative(this.container);
  },
};

export {loadVideoNative, LoadVideoNative};
